export const SITE_STATS_KEYS = [
    'totalPeople',
    'totalDocuments',
    'totalPhotos',
    'totalPlaces',
    'uniqueLastnames'
];

export function normalizeGrowthRows(rows = []) {
    if (!Array.isArray(rows)) return [];

    return rows
        .map((row) => {
            const shiftedDate = shiftCronDate(row.date);
            if (!shiftedDate) return null;

            return {
                ...row,
                date: shiftedDate
            };
        })
        .filter(Boolean)
        .sort((a, b) => String(a.date).localeCompare(String(b.date)));
}

export function overlayCurrentStats(rows = [], currentStats = null, today = getTodayKey()) {
    if (!currentStats || !today) return rows;

    const currentRow = SITE_STATS_KEYS.reduce((row, key) => {
        row[key] = Number(currentStats[key] || 0);
        return row;
    }, { date: today });

    const nextRows = [...rows];
    const todayIndex = nextRows.findIndex((row) => row.date === today);

    if (todayIndex >= 0) {
        nextRows[todayIndex] = currentRow;
        return nextRows;
    }

    nextRows.push(currentRow);
    return nextRows.sort((a, b) => String(a.date).localeCompare(String(b.date)));
}

export function filterUnchangedGrowthRows(rows = []) {
    if (rows.length <= 1) return rows;

    const filtered = [rows[0]];

    for (let i = 1; i < rows.length; i++) {
        const current = rows[i];
        const previous = rows[i - 1];
        const hasChanges = SITE_STATS_KEYS.some((key) => current[key] !== previous[key]);

        if (hasChanges || i === rows.length - 1) {
            filtered.push(current);
        }
    }

    return filtered;
}

export function calculateCurrentMonthDeltas(rows = [], today = getTodayKey()) {
    const monthKey = String(today).slice(0, 7);
    const latestCurrentMonthRow = [...rows].reverse().find((row) => row.date?.startsWith(monthKey));
    const latestPreviousRow = [...rows].reverse().find((row) => !row.date?.startsWith(monthKey));

    if (!latestCurrentMonthRow || !latestPreviousRow) {
        return {};
    }

    return SITE_STATS_KEYS.reduce((deltas, key) => {
        const current = Number(latestCurrentMonthRow[key]);
        const previous = Number(latestPreviousRow[key]);

        if (Number.isFinite(current) && Number.isFinite(previous)) {
            deltas[key] = current - previous;
        }

        return deltas;
    }, {});
}

export function buildCurrentMonthDeltas(growthData, currentStats, today = getTodayKey()) {
    const rows = filterUnchangedGrowthRows(
        overlayCurrentStats(
            normalizeGrowthRows(growthData?.rows),
            currentStats,
            today
        )
    );

    return calculateCurrentMonthDeltas(rows, today);
}

function shiftCronDate(dateValue) {
    if (!dateValue) return '';

    const date = new Date(`${dateValue}T12:00:00`);
    if (Number.isNaN(date.getTime())) return '';

    date.setDate(date.getDate() - 1);
    return date.toISOString().split('T')[0];
}

function getTodayKey() {
    return new Date().toISOString().split('T')[0];
}
